export const QPARAMS_CHANGED = "tasks/QParamsChanged";
export const CUSTOMERS_QPARAMS_CHANGED = "tasks/CustomersQParamsChanged";
export const TASK_CUSTOMERS_QPARAMS_CHANGED = "tasks/TaskCustomersQParamsChanged";
export const SURVEYS_QPARAMS_CHANGED = "tasks/SurveysQParamsChanged";
export const _QPARAMS_CHANGED = "tasks/SurveysQParamsChanged";

export const TASK_SURVEYS = "tasksSurveys";
export const TASK_SURVEYS_LOADING = "taskSurveysLoading";

export const CUSTOMERS = "customers";
export const EQUIPMENT_ID = 'equipmentId';
export const CUSTOMERS_COUNT = "customersCount";
export const CUSTOMERS_LOADING = "customersLoading";

export const REJECTION_REASONS_LOADING = 'rejectionReasonsLoading';
export const REJECTION_REASONS = 'rejectionReasons';

export const TASK_DETAILS = 'taskDetails';
export const TASK_ORDER = 'taskOrder';
export const TASK_ORDER_LOADING = 'taskOrderLoading';

export const TASK_CATEGORIES = 'taskCategories';

export const TASK_ORIGIN = "taskOrigin";
export const TASK_ORIGIN_CODE = 0;


export const MARKET_SCAN = 'MSA';
export const SURVEY = 'SUR';
export const VISIT = 'VIS';
export const CUSTOMER_DEVELOPMENT = 'CDE';
export const NEW_CUSTOMER = 'NCUS';
export const CHANGE_CUSTOMER = 'CCUS';
export const ORDER = 'ORD';
export const REPLENISHMENT = 'RPL';
export const PLACEMENT_ACTIVATION = 'EPA';
export const REMOVAL_DEACTIVATION = 'ERD';
export const MAINTENANCE = 'EM';
export const SERVER_CABINET_INSPECTION = 'SCI';
export const CUSTOMER_REQUEST = 'CRE'


// CONTANCT PERSONS
export const PARTICIPANTS = 'participants';
export const CUSTOMER_CONTACT_FOR = 'customerContactsFor';
export const CUSTOMER_CONTACT_FOR_LOADING = 'customerContactsForLoading';
export const CUSTOMER_CONTACT_PERSONS = 'cusotmerContanctPersons';
export const CUSTOMER_CONTACT_PERSON_ID = 'customerPersonId';
export const CUSTOMER_CONTACT_PERSON_NAME = 'name';
export const CUSTOMER_CONTACT_PERSON_EMAIL = 'email';
export const CUSTOMER_CONTACT_PARTICIPANT_TYPE = 'participantType';

export const CUSTOMER_DEVELOPMENT_TYPES = 'customerDevelopmentTypes';
export const CUSTOMER_DEVELOPMENT_TYPES_LOADING = 'customerDevelopmentTypesLoading';

export const ASSIGNED_TO_LIST = 'assignedToList';
export const ASSIGNED_TO_LIST_LOADING = 'assignedToListLoading';

export const TASK_TYPE_CUSTOMER_DEV = [
    CUSTOMER_DEVELOPMENT,
]

export const TASK_TYPE_CODES_WITH_EQUIPMENT = [
    PLACEMENT_ACTIVATION,
    REMOVAL_DEACTIVATION,
    MAINTENANCE,
    SERVER_CABINET_INSPECTION,
    REPLENISHMENT,
];

export const TASK_TYPES_WITH_PLACEMENT_AND_ACT = [
    // 'EPA',
]

export const TEAMS = 'TEAMS';
export const PHONECALL = 'PHONECALL';
export const INPERSON = 'INPERSON';

export const MEETING_TYPE_CODES = [
    INPERSON,
    PHONECALL,
    TEAMS
];